import { PhoneFilled, PlusOutlined } from "@ant-design/icons";
import { Button, TreeSelect as AntTreeSelect } from "antd";
import * as _ from "lodash";
import style from "./treeSelect.module.less";
import cn from "classnames";
import i18n, { languageKeys } from "../../i18n";

const { SHOW_ALL, SHOW_PARENT, SHOW_CHILD } = AntTreeSelect;

export const TreeSelect = ({
  dataSource = [],
  placeholder = i18n.t(languageKeys.common_Chon),
  checkedStrategy = SHOW_CHILD,
  treeCheckable = true,
  treeDefaultExpandAll = true,
  showSearch = true,
  allowClear = true,
  isParentUncheckable = true,
  onClear,
  checkChildren = false,
  addItemProps = {
    visible: false,
    onAddItem: () => {},
    textAddItem: "Add Item",
  },
  onSelect = () => {},
  onDeselect = () => {},
  readOnly = false,
  popupClassName,
  ...props
}) => {
  const visibleAddItem = _.isObject(addItemProps) && addItemProps.visible;

  const handleSelect = (value, node, isDeselect = false) => {
    if (readOnly) return;
    if (isDeselect) {
      if(checkChildren) onDeselect(value, node?.children)
        else onDeselect(value, node?.fullValue)
      
    } else {
      if(checkChildren) onSelect(value, node?.children)
        else onSelect(value, node.fullValue)
    };
  };

  const getDataSource = () => {
    if (!isParentUncheckable) return dataSource;

    const formatItemHasChildren = (item) => {
      let item_has_children = { ...item, selectable: false, checkable: false };

      const children = item_has_children.children;

      if (readOnly) {
        item.disabled = true;
      }

      item_has_children.children = children.map((child) => {
        if (!child.children) return child;
        return formatItemHasChildren(child);
      });

      return item_has_children;
    };

    return dataSource.map((item) => {
      if (!item.children) {
        if (readOnly) {
          item.disabled = true;
        }
        return item;
      }
      return formatItemHasChildren(item);
    });
  };

  const dropdownRender = (originNode) => {
    return (
      <>
        {originNode}

        {visibleAddItem && (
          <div
            style={{
              borderTop: "1px solid #fafafa",
              paddingTop: 7,
            }}
          >
            <Button type="link" icon={<PlusOutlined />} onClick={addItemProps?.onAddItem}>
              {addItemProps.textAddItem || "Add Item"}
            </Button>
          </div>
        )}
      </>
    );
  };

  // console.log('fffffffffffff', dataSource, getDataSource())

  return (
      <AntTreeSelect
          maxTagCount={2}
          treeData={getDataSource()}
          treeCheckable={treeCheckable}
          treeDefaultExpandAll={treeDefaultExpandAll}
          placeholder={placeholder}
          showSearch={showSearch}
          allowClear={allowClear}
          dropdownRender={dropdownRender}
          onSelect={(value, node) => handleSelect(value, node)}
          onDeselect={(value, node) => handleSelect(value, node, true)}
          onClear={onClear}
          popupClassName={cn(isParentUncheckable && style["parent-uncheck"], style["dropdown"], popupClassName)}
          className={style["input"]}
          style={{ width: "100%" }}
          showCheckedStrategy={checkedStrategy}
          {...props}
      />
  );
};

TreeSelect.checkedStrategy = { SHOW_ALL, SHOW_PARENT, SHOW_CHILD };
